import { PrismButton } from "@prism-ui/react";
import { useNavigate } from "react-router";

const Unauthorized = () => {
  const navigate = useNavigate();
  return (
    <div className="unauthorized-page" style={{paddingTop: "2em"}}>
      <h2>You do not have permission to view this page.</h2>
      <PrismButton tone="primary" onPrismClick={() => navigate("/")}>
        Return Home
      </PrismButton>
    </div>
  )
}

export default Unauthorized
